export const GET_ACCOUNT = 'GET_ACCOUNT';

export const GET_APP_AUTHENTICATION = 'GET_APP_AUTHENTICATION';

export const GET_ARTICLE = 'GET_ARTICLE';
export const GET_ARTICLES = 'GET_ARTICLES';

export const GET_BELIEF_STATEMENTS = 'GET_BELIEF_STATEMENTS';

export const GET_CHANNEL = 'GET_CHANNEL';
export const GET_CHANNELS = 'GET_CHANNELS';

export const GET_COMMITMENT = 'GET_COMMITMENT';
export const GET_COMMITMENTS = 'GET_COMMITMENTS';

export const GET_DRAWER = 'GET_DRAWER';

export const GET_EPISODE = 'GET_EPISODE';
export const GET_EPISODES = 'GET_EPISODES';
export const GET_EPISODES_AGGREGATIONS = 'GET_EPISODES_AGGREGATIONS';
export const GET_EPISODES_AGGREGATIONS_BY_CHANNEL = 'GET_EPISODES_AGGREGATIONS_BY_CHANNEL';
export const GET_EPISODES_AGGREGATIONS_BY_SPEAKER = 'GET_EPISODES_AGGREGATIONS_BY_SPEAKER';
export const GET_EPISODES_AGGREGATIONS_BY_YEAR = 'GET_EPISODES_AGGREGATIONS_BY_YEAR';
export const GET_EPISODES_AGGREGATIONS_BY_TAGS = 'GET_EPISODES_AGGREGATIONS_BY_TAGS';
export const GET_EPISODES_PAGINATION = 'GET_EPISODES_PAGINATION';

export const GET_EPISODE_COLLECTION = 'GET_EPISODE_COLLECTION';
export const GET_EPISODE_COLLECTIONS = 'GET_EPISODE_COLLECTIONS';
export const GET_EPISODE_COLLECTIONS_PAGINATION = 'GET_EPISODE_COLLECTIONS_PAGINATION';

export const GET_EVENT = 'GET_EVENT';
export const GET_EVENTS = 'GET_EVENTS';

export const GET_EVENT_REGISTRATION_FIELDS = 'GET_EVENT_REGISTRATION_FIELDS';
export const GET_EVENT_REGISTRATION_PARTICIPANTS = 'GET_EVENT_REGISTRATION_PARTICIPANTS';

export const GET_MATERIAL = 'GET_MATERIAL';
export const GET_MATERIALS = 'GET_MATERIALS';

export const GET_MEMBER = 'GET_MEMBER';
export const GET_MEMBER_LOCAL_STORAGE_KEY = 'GET_MEMBER_LOCAL_STORAGE_KEY';

export const GET_MINISTRY = 'GET_MINISTRY';
export const GET_MINISTRIES = 'GET_MINISTRIES';

export const GET_ORDER = 'GET_ORDER';

export const GET_PAGE = 'GET_PAGE';

export const GET_PROJECT = 'GET_PROJECT';
export const GET_PROJECTS = 'GET_PROJECTS';

export const GET_QUESTIONS = 'GET_QUESTIONS';

export const GET_SERVICES = 'GET_SERVICES';
export const GET_SERVICES_AGGREGATIONS = 'GET_SERVICES_AGGREGATIONS';
export const GET_SERVICES_FILTERS = 'GET_SERVICES_FILTERS';
export const GET_SERVICES_MODE = 'GET_SERVICES_MODE';
export const GET_SERVICES_NEXT_PAGE = 'GET_SERVICES_NEXT_PAGE';
export const GET_SERVICES_REFRESH = 'GET_SERVICES_REFRESH';

export const GET_SPEAKER = 'GET_SPEAKER';
export const GET_SPEAKERS = 'GET_SPEAKERS';
export const GET_SPEAKERS_PAGINATION = 'GET_SPEAKERS_PAGINATION';

export const GET_STAFF_MEMBER = 'GET_STAFF_MEMBER';
export const GET_STAFF_MEMBERS = 'GET_STAFF_MEMBERS';

export const GET_WAIVER = 'GET_WAIVER';
